import React from "react";
import { ResizableBox as ReactResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";

import Legend from "./Legend";

export default function ResizableBox({
  children,
  width = Infinity, // Fix to make ResizableBox take width of parent component.
  height = 300,
  resizable = true,
  style = {},
  className = "",
  title
}) {
  return (
    <div className="resizable-div" style={{ marginLeft: 20, marginRight: 20 }}>
      <div
        style={{
          display: "inline-block",
          width: "100%",
          background: "white",
          padding: ".5rem",
          borderRadius: "0.5rem",
          boxShadow: "0 30px 40px rgba(0,0,0,.1)",
          ...style,
        }}
      >
        {resizable ? (
          <div>
            <p className="vertical-center chart-title">{title}</p>

            <div id="chart-container" className="chart-container">
              <p className="vertical-center y-label">Antal</p>
              {/* <div> */}

                <ReactResizableBox width={width} height={height}>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    className={className}
                  >
                    {children}
                  </div>
                </ReactResizableBox>
              {/* </div> */}
            </div>
                <p className="vertical-center x-label">Datum</p>

              <Legend />

          </div>
        ) : (
          <div>
            <p className="vertical-center chart-title">{title}</p>
            <div className="chart-container">
              <p className="vertical-center y-label">Antal</p>
              <div
                style={{
                  width: `${width}px`,
                  height: `${height}px`,
                }}
                className={className}
              >
                {children}
              </div>
            </div>
            <p className="vertical-center x-label">Datum</p>
            <Legend />
          </div>
        )}
      </div>
    </div>
  );
}